(function () {
  var REDUCED = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var HTML = document.documentElement;
  /* Scroll reveal + count-ups (2026-10-16, round 2). Animation is for the shopper; never bend motion for Clarity replays
     (Jay: "I remembered about animations causing havoc in clarity recordings so we had the animations changed. I don't
     like that change."). This replaces the 2026-09-20/22 versions (arm on scroll intent, the 2.2-viewport band, animate
     FROM VISIBLE), which played each block's entrance after it was already painted, so the keyframe's first frame blinked
     it out (50 of 57 blocks at 375). Clarity replays and heatmaps may now show blocks that were never scrolled to: accepted.
     Rules (every v3 template; the club adds its card grids and press outlets):
     - Hidden before it can paint. html.v3-enter-arm (the hero's inline arm script, before any section paints, never under
       reduced motion) holds every target outside the hero at opacity 0 in the sheet. Here, at DOMContentLoaded, a target
       below the fold takes .v3r (held by the sheet on its own) and is observed; the arm then drops when the hero entrance
       ends (~1.5s, 1.2s in a background tab). That is also the safety net: if this file never runs, nothing is held past it.
     - Revealed as it arrives: .v3r-in plays the sheet's v3-reveal keyframe (fill backwards, so a landed block keeps no
       animation and no pinned transform). Blocks that arrive in the same callback stagger 60ms apart, at most 180ms.
     - Nothing visible is ever hidden. A target already on screen (or above it) here is left exactly as it is; if the arm
       held it from first paint (scroll restoration, a very tall screen) it fades in now, with the entrance.
     - A block passed without intersecting (fast flick, jump link, restored scroll) ends revealed: the observer's root
       reaches far above the viewport, so passing a block still reports it, and a block above the screen is revealed with
       no animation.
     Count-ups (2026-09-07, owner's ask): any element with data-count-nums has each run of digits wrapped in a span. A span
     below the fold is parked now on the lowest value with the same digit count (200,000 from 100,000; 80 from 10; 3 from
     0), pinned at its final width so the headline holds still, and rolls when its block is revealed (waiting for the
     block to land) or, outside a reveal block, when half of it is on screen. A span on screen here keeps its final value
     and never snaps back. "Touch 2" is a product name and never counts. Reduced motion wraps (gold) but never counts. */
  function wrapNums(host) {
    var out = [], walker = document.createTreeWalker(host, NodeFilter.SHOW_TEXT, null), nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (t) {
      var text = t.nodeValue, re = /(\d{1,3}(?:,\d{3})+(?:\.\d+)?|\d+(?:\.\d+)?)([+%])?/g, m, last = 0, frag = null;
      while ((m = re.exec(text))) {
        if (/Touch\s$/.test(text.slice(0, m.index))) continue;
        if (!frag) frag = document.createDocumentFragment();
        frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var sp = document.createElement('span');
        sp.className = 'cnt'; sp.textContent = m[0];
        sp.setAttribute('data-end', m[1].replace(/,/g, ''));
        sp.setAttribute('data-comma', m[1].indexOf(',') > -1 ? '1' : '0');
        sp.setAttribute('data-dec', String((m[1].split('.')[1] || '').length));
        sp.setAttribute('data-suffix', m[2] || ''); /* + or % rides with the figure, in its colour, and never counts */
        frag.appendChild(sp); out.push(sp); last = m.index + m[0].length;
      }
      if (frag) { frag.appendChild(document.createTextNode(text.slice(last))); t.parentNode.replaceChild(frag, t); }
    });
    return out;
  }
  function countFmt(v, dec, comma) {
    var str = v.toFixed(dec);
    if (comma) { var parts = str.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); str = parts.join('.'); }
    return str;
  }
  function countFrom(end) {
    var d = String(Math.floor(Math.abs(end))).length;
    return d > 1 ? Math.pow(10, d - 1) : 0;
  }
  function cv(sp) { return { end: parseFloat(sp.getAttribute('data-end')), dec: +sp.getAttribute('data-dec'), comma: sp.getAttribute('data-comma') === '1', suf: sp.getAttribute('data-suffix') || '' }; }
  /* pin the span at its final width (measured on the final text, in this task, so the final value is never painted), then park it */
  function countArm(sp) {
    var c = cv(sp); if (!(c.end > 0)) return;
    sp.style.display = 'inline-block'; sp.style.textAlign = 'right'; sp.style.minWidth = '';
    sp.textContent = countFmt(c.end, c.dec, c.comma) + c.suf;
    sp.style.minWidth = sp.getBoundingClientRect().width + 'px';
    if (!sp.closest('.v3r')) sp.textContent = countFmt(countFrom(c.end), c.dec, c.comma) + c.suf;   /* in a held block the real value stays in the markup until its roll starts */
    sp._parked = true;
  }
  function countEnd(sp) { var c = cv(sp); sp._parked = false; sp.textContent = countFmt(c.end, c.dec, c.comma) + c.suf; }
  function countRun(sp, wait) {
    if (!sp._parked) return; sp._parked = false;
    var c = cv(sp), from = countFrom(c.end), span = c.end - from;
    var dur = c.end >= 1000 ? 1400 : c.end >= 20 ? 1100 : 700;
    var t0 = performance.now() + (wait || 0);
    sp.textContent = countFmt(from, c.dec, c.comma) + c.suf;   /* its block is still at opacity 0 here */
    setTimeout(function () { sp.textContent = countFmt(c.end, c.dec, c.comma) + c.suf; }, (wait || 0) + dur + 100);   /* lands even if rAF stalls */
    function frame(now) {
      var t = Math.min(1, Math.max(0, (now - t0) / dur)), e = 1 - Math.pow(1 - t, 3);
      sp.textContent = countFmt(t < 1 ? from + span * e : c.end, c.dec, c.comma) + c.suf;
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  function init() {
    var spans = [];
    document.querySelectorAll('.pdp-v3 [data-count-nums]').forEach(function (h) { spans = spans.concat(wrapNums(h)); });
    if (REDUCED || !('IntersectionObserver' in window)) return;
    var club = HTML.classList.contains('pdp-club');
    var sels = [
      '.sec .wrap > :first-child',
      '#method .msx',
      '#compare .tablewrap', '#compare .tnote',
      '#why .micro > div',
      '.feats > div',
      '#reviews .qt',
      '.guar > div',
      '#faq details',
      '.statbar > div',
      '.final h2', '.final p', '.final .cta'
    ];
    /* club template: its card grids reveal card by card, and the press bar outlet by outlet (not as one grid) */
    if (club) sels = sels.concat(['.fg-cards > .fg-card', '.mcards > .mcard', '.specstrip > div', '.pressgrid > .pressitem']);
    var els = [];
    sels.forEach(function (s) {
      document.querySelectorAll('.pdp-v3 ' + s).forEach(function (e) {
        if (e.closest('.hero') || (club && e.classList.contains('pressgrid'))) return;
        if (els.indexOf(e) === -1) els.push(e);
      });
    });
    var vh = window.innerHeight || HTML.clientHeight;
    var held = HTML.classList.contains('v3-enter-arm');   /* the sheet has held every target since first paint */
    var FAR = '100000px 0px -8% 0px';   /* root reaches far above the viewport: passing a block still reports it */
    var countIn = function (el, wait) { spans.forEach(function (sp) { if (sp._parked && el.contains(sp)) countRun(sp, wait); }); };
    var countNow = function (el) { spans.forEach(function (sp) { if (sp._parked && el.contains(sp)) countEnd(sp); }); };
    var io = new IntersectionObserver(function (ents) {
      var k = 0;
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target; io.unobserve(el);
        if (en.boundingClientRect.bottom <= 0) { el.style.animation = 'none'; el.classList.add('v3r-in'); countNow(el); return; }   /* passed unseen */
        var d = Math.min(k++ * 60, 180);
        el.style.animationDelay = d + 'ms'; el.classList.add('v3r-in');
        countIn(el, d + 380);   /* the roll reads cleaner on solid ink: let the block land first */
      });
    }, { rootMargin: FAR, threshold: 0 });   /* the top edge crossing the line 8% above the fold starts it, whatever the block's height */
    var cio = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        cio.unobserve(en.target);
        if (en.boundingClientRect.bottom <= 0) countEnd(en.target); else countRun(en.target, 0);
      });
    }, { rootMargin: '100000px 0px 0px 0px', threshold: 0.5 });
    var onScreen = [];
    els.forEach(function (e) {
      var r = e.getBoundingClientRect();
      if (r.top >= vh) { e.classList.add('v3r'); io.observe(e); return; }
      if (!held) return;   /* painted and on screen (or above): it stays exactly as it is */
      if (r.bottom <= 0) { e.style.animation = 'none'; e.classList.add('v3r-in'); return; }
      onScreen.push(e);
    });
    /* count-ups after the holds: a span below the fold is pinned; only one outside a held block is parked now */
    spans.forEach(function (sp) { if (sp.getBoundingClientRect().top >= vh) countArm(sp); });
    onScreen.forEach(function (e, i) { e.style.animationDelay = Math.min(i * 60, 180) + 'ms'; e.classList.add('v3r-in'); });   /* held from first paint, on screen now: rides in with the hero */
    /* a parked span outside any held block rolls on its own, when half of it is on screen */
    spans.forEach(function (sp) { if (sp._parked && !(sp.closest && sp.closest('.v3r'))) cio.observe(sp); });
    /* the width pin was measured on whatever font had loaded; re-pin once the webfont is in (final text measured in-task) */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { spans.forEach(function (sp) { if (sp._parked) countArm(sp); }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
